import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import LoginLogo from "../../assets/images/logo-full.png";

const Login = () => {
  const email = useRef();
  const password = useRef();
  const nav = useNavigate();
  const [showError, setShowError] = useState();
  const [customError, setCustomError] = useState({ show: false, message: "" });
  const formSubmitHandler = async (e) => {
    e.preventDefault();

    if (email.current.value === "" || password.current.value === "") {
      setShowError(true);
      return;
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}login`, {
      method: "POST",
      body: JSON.stringify({
        username: email.current.value,
        password: password.current.value,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    const { status } = response;
    const resData = await response.json();
    if (status === 200) {
      localStorage.setItem("user", resData.user);
      nav("/admin/dashboard");
      return;
    } else {
      setCustomError({ show: true, message: resData.message });
    }
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>The Bio -Login</title>
      </Helmet>
      <div className="vh-100">
        <div className="authincation h-100">
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center">
              <div className="col-md-6">
                <div className="authincation-content">
                  <div className="row no-gutters">
                    <div className="col-xl-12">
                      <div className="auth-form">
                        <div className="text-center mb-3">
                          <Link to="/admin">
                            <img src={LoginLogo} alt="" />
                          </Link>
                        </div>
                        <h4 className="text-center mb-4">
                          Sign in your account
                        </h4>
                        {customError.show && (
                          <div class="alert alert-danger solid alert-rounded ">
                            <strong>Error!</strong> {customError.message}
                          </div>
                        )}
                        <form
                          className={`needs-validation ${
                            showError && "was-validated"
                          }`}
                          onSubmit={formSubmitHandler}
                          noValidate
                        >
                          <div className="mb-3">
                            <label className="mb-1">
                              <strong>Email</strong>
                            </label>
                            <input
                              ref={email}
                              type="email"
                              className="form-control"
                              placeholder="admin@admin.com"
                              required
                            />
                            <div className="invalid-feedback">
                              Please provide email.
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="mb-1">
                              <strong>Password</strong>
                            </label>
                            <input
                              ref={password}
                              type="password"
                              className="form-control"
                              placeholder="Password"
                              required
                            />
                            <div className="invalid-feedback">
                              Please provide password.
                            </div>
                          </div>
                          {/* <div className="row d-flex justify-content-between mt-4 mb-2">
                            <div className="mb-3">
                              <div className="form-check custom-checkbox ms-1">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="basic_checkbox_1"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="basic_checkbox_1"
                                >
                                  Remember my preference
                                </label>
                              </div>
                            </div>
                          </div> */}
                          <div className="text-center">
                            <button
                              type="submit"
                              className="btn btn-primary btn-block"
                            >
                              Sign Me In
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
